// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/freezing-precipitation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/freezing-precipitation/freezing-precipitation.js';
import g1 from '../lessons/meteorology/freezing-precipitation/precipitation-by-temperature-profile.js';

mount([g0, g1]);
